import { ca } from '@cian/analytics';

export function trackOpenCommentsBlock() {
  ca('event', {
    action: 'comment_open_main_block',
    category: 'card',
    label: '',
    name: 'oldevent',
  });
}
